"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : ACCENT : STYLES --------------- ++++++++++ */


var _default = {
  accent: {
    color: _index.theme.color.supporting.dark.swatch,
    opacity: '.4'
  }
};
exports.default = _default;